import initializeCarousel from '@bit/pitcher.components.carousel'
import '@bit/pitcher.carousel.carousel-thumbnails'
import '@bit/pitcher.carousel.carousel-navigation'

const carouselData = {
	'carousel--inline': {
		contain: true,
		cellAlign: 'center',
		pageDots: false,
		prevNextButtons: false,
		setGallerySize: false
	},
	'carousel--thumbnails': {
		cellAlign: 'left',
		pageDots: false,
		prevNextButtons: false,
		thumbnails: {
			target: '.o-carousel .carousel--inline'
		}
	},
	'carousel--feed': {
		contain: true,
		cellAlign: 'left',
		pageDots: false,
		prevNextButtons: false,
		customNavigation: {
			previousSelector: '.a-btn--previous',
			nextSelector: '.a-btn--next'
		}
	},
	'carousel--mobile': {
		contain: true,
		cellAlign: 'left',
		groupCells: true,
		pageDots: true,
		prevNextButtons: false,
		watchCSS: true
	}
}

window.addEventListener('load', () => {
	initializeCarousel({
		data: carouselData
	})
})



// WEBPACK FOOTER //
// ./js/modules/content/media/carousel.js